var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeMiterlimit: 10,
  strokeWidth: 1.25,
  d: "M7.831 7.087c-1.51 0-2.732-1.09-2.732-2.435V3.435C5.099 2.09 6.32 1 7.83 1s2.732 1.09 2.732 2.435v1.217c0 1.345-1.222 2.435-2.732 2.435ZM5.208 8.913a.5.5 0 0 1 .396.195c.492.62 1.305 1.022 2.227 1.022s1.728-.401 2.227-1.022a.52.52 0 0 1 .396-.195c2.322 0 4.208 1.68 4.208 3.75v1.71c0 .347-.315.627-.704.627H1.704c-.39 0-.704-.28-.704-.627v-1.71c0-2.07 1.885-3.75 4.208-3.75Z"
})));
export default SvgProfile;